import { ErrorMessageP } from './styles';

interface Props {
	error: string;
}

const ErrorMessage = ({ error }: Props) => {
	if (!error || !error.length) {
		return null;
	}
	return <ErrorMessageP>{error}</ErrorMessageP>;
};

export default ErrorMessage;
